/* Source behavior: source-products/*, an_announcement_timer / 3 days.
   One clock for announcement, product pill and Chapter II; no invented deadline. */
(() => {
  if (window.pnRuntimeFix) return;
  const KEY = 'an_announcement_timer', DURATION = 3 * 24 * 60 * 60 * 1000;
  let end = 0;
  const read = () => { try { return Number(localStorage.getItem(KEY)); } catch (_) { return 0; } };
  const save = () => { try { localStorage.setItem(KEY, String(end)); } catch (_) {} };
  end = read();
  function tick() {
    const now = Date.now();
    if (!Number.isFinite(end) || end <= now) { end = now + DURATION; save(); }
    const seconds = Math.floor((end - now) / 1000);
    const parts = [Math.floor(seconds / 86400), Math.floor(seconds % 86400 / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(n => String(n).padStart(2, '0'));
    const selectors = ['[id="an-days"], [id="anChD"]', '[id="an-hours"], [id="anChH"]', '[id="an-mins"], [id="anChM"]', '[id="an-secs"], [id="anChS"]'];
    selectors.forEach((selector,i) => document.querySelectorAll(selector).forEach(el => { el.textContent = parts[i]; }));
    document.querySelectorAll('.an-cdt').forEach(el => { el.textContent = `${parts[0]}d ${parts.slice(1).join(':')}`; });
  }
  function init(root = document) {
    root.querySelectorAll('details.product-info__accordion').forEach(el => {
      el.removeAttribute('aria-expanded');
      el.removeAttribute('is');
      // Native disclosure semantics replace Impact's absent animated details component.
    });
    tick();
  }
  window.pnRuntimeFix = { init, tick };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('pn:quick-add:loaded', event => init(event.target));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
  window.addEventListener('storage', event => { if (event.key === KEY) { end = read(); tick(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  setInterval(tick, 1000);
})();

/* Visual cart reminder only: never changes cart contents, availability or checkout. */
(() => {
  if (customElements.get('pn-cart-countdown')) return;
  const KEY = 'pn:cart-countdown:v1';
  const DURATION = 600000, ZERO_FRAME = 1000, CYCLE = DURATION + ZERO_FRAME;
  const elements = new Set();
  let deadline = 0, interval = null, controller = null;
  const save = () => { try { sessionStorage.setItem(KEY, String(deadline)); } catch (_) {} };
  const read = () => { try { return Number(sessionStorage.getItem(KEY)); } catch (_) { return 0; } };
  function tick() {
    const now = Date.now();
    if (!deadline) deadline = read();
    if (!Number.isFinite(deadline) || deadline <= 0 || deadline > now + DURATION) {
      deadline = now + DURATION;
      save();
    } else if (now >= deadline + ZERO_FRAME) {
      // Retain the cycle phase after background throttling or navigation.
      deadline += (Math.floor((now - deadline - ZERO_FRAME) / CYCLE) + 1) * CYCLE;
      save();
    }
    const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
    const value = `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;
    elements.forEach(element => {
      if (element.output.textContent !== value) element.output.textContent = value;
      element.hidden = false;
    });
  }
  function pause() {
    if (interval !== null) clearInterval(interval);
    interval = null;
  }
  function resume() {
    pause();
    if (document.hidden || !elements.size) return;
    tick();
    interval = setInterval(tick, 1000);
  }
  function connect(element) {
    elements.add(element);
    if (!controller) {
      controller = new AbortController();
      const options = { signal: controller.signal };
      document.addEventListener('visibilitychange', resume, options);
      window.addEventListener('pagehide', pause, options);
      window.addEventListener('pageshow', resume, options);
    }
    tick();
    if (interval === null && !document.hidden) interval = setInterval(tick, 1000);
  }
  function disconnect(element) {
    elements.delete(element);
    if (elements.size) return;
    pause();
    controller?.abort();
    controller = null;
  }
  customElements.define('pn-cart-countdown', class extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-pn-cart-countdown-value]');
      if (this.output) connect(this);
    }
    disconnectedCallback() {
      disconnect(this);
      this.output = null;
    }
  });
})();
